export enum ManageImageGalleryOperation
{
    Add = 'add',
    AddBulk = 'add-bulk',
    Delete = 'delete',
    DeleteBulk = 'delete-bulk',
    Move = 'move',
    SetDefault = 'set-default'
}